import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TalentProfilePage } from '../../../enums';

@Injectable({
  providedIn: 'root'
})
export class PageService {
  private activePageSubject = new BehaviorSubject<TalentProfilePage>(TalentProfilePage.EMPLOYMENT_SPLASH_PAGE);
  activePage$ = this.activePageSubject.asObservable();

  setActivePage(page: TalentProfilePage) {
    this.activePageSubject.next(page);
  }
}
